module.exports = __webpack_public_path__ + "static/Phones-391f91d63eae4c1736aafd340861728b.png";